import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";
import { TemplateContent, TemplateContentDTO } from "./templateContent";
/* eslint-disable import/export */
export abstract class GetEmailTemplateDetailsRPC implements
  LeoRPC<GetEmailTemplateDetailsRPC.Request, GetEmailTemplateDetailsRPC.Response, GetEmailTemplateDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetEmailTemplateDetailsRPC.Request
  ): Promise<LeoRPCResult<GetEmailTemplateDetailsRPC.Response, GetEmailTemplateDetailsRPC.Errors.Errors>>;
}

export namespace GetEmailTemplateDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    templateId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetEmailTemplateDetailsRPCRequest: boolean = true;
  
    readonly templateId: LeoUUID;
  
  
    constructor(
    templateId: LeoUUID
    ) {
      this.templateId = templateId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const templateId = getLeoUuid(dto, "templateId", InvalidRequestTemplateIdError);
      return new Request(
        templateId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          templateId: this.templateId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetEmailTemplateDetailsRPC(templateId='${this.templateId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    templateName: BoundedNameDTO;
    templateContent: TemplateContentDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetEmailTemplateDetailsResponse: boolean = true;
  
    readonly templateName: BoundedName;
    readonly templateContent: TemplateContent;
  
  
    constructor(
    templateName: BoundedName, 
    templateContent: TemplateContent
    ) {
      this.templateName = templateName;
      this.templateContent = templateContent;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const templateName = BoundedName.fromDTO(getObject(dto, "templateName", InvalidResponseTemplateNameError));
      const templateContent = TemplateContent.fromDTO(getObject(dto, "templateContent", InvalidResponseTemplateContentError));
      return new Response(
        templateName,
        templateContent
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          templateName: this.templateName.toDTO(),
          templateContent: this.templateContent.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetEmailTemplateDetails(templateName='${this.templateName}',templateContent='${this.templateContent}')`;
  };
  

  export enum RPCError {
    InvalidTemplateId = "INVALID_TEMPLATE_ID"
  }

  export namespace Errors {
    
    export interface InvalidTemplateIdDTO {
      code: string;
    }
    
    export class InvalidTemplateId extends LeoRPCError<RPCError> {
      readonly isInvalidTemplateId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidTemplateId;
        super(code);
      }
    
    
      toDTO(): InvalidTemplateIdDTO {
        const dto: InvalidTemplateIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidTemplateId.prototype.toString = function toString(): string {
      return `GetEmailTemplateDetailsRPC.INVALID_TEMPLATE_ID()`;
    };
    

    export type Errors = InvalidTemplateId;
    export type ErrorsDTO = InvalidTemplateIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidTemplateId:
          return new InvalidTemplateId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestTemplateIdError extends GetEmailTemplateDetailsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTemplateIdError";
  }
}

export class InvalidResponseTemplateNameError extends GetEmailTemplateDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTemplateNameError";
  }
}

export class InvalidResponseTemplateContentError extends GetEmailTemplateDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTemplateContentError";
  }
}

export class InvalidResponseInvalidTemplateIdError extends GetEmailTemplateDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidTemplateIdError";
  }
}

